<template>
  <div class="w-100  p-map-salon-map-main">
    <l-map
    :zoom="zoom"
    :center="center"
    :options="mapOptions"
    @update:center="centerUpdate"
    @update:zoom="zoomUpdate($event)"
    @click="addMarker"
    >
    <l-tile-layer
    :url="url"
    />

    <l-marker
    v-for="data in markers" :key="data.id"
    :lat-lng="data.position"
    :icon="data.icon"
    >
    <l-tooltip :options="{ permanent: true, interactive: true }">
        <h3 class="p-map-tooltip">{{data.title}}</h3>
    </l-tooltip>
  </l-marker>

</l-map>

</div>
</template>

<script>
import { latLng,icon,L,map  } from "leaflet";

export default {
  name: "mapData",
  components: {
  },

  props: {
    locationData          : {type:[Array,Object],default:[]},
  },


  data() {
    return {
      zoom: 18,
      center: latLng(30.2791476,57.0745852),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      withPopup: latLng(30.2791476,57.0745852),
      currentZoom: 11.5,
      showParagraph: false,
      mapOptions: {
        zoomSnap    : 0.5,
      },
      showMap   : true,
      // icon: icon({
      //   // iconUrl: "../img/icons/pin.png",
      //   iconUrl: "../../img/icons/pin.png",
      //   iconSize: [42 ,42],
      //   iconAnchor: [16, 37]
      // }),
      markers: [
      ],
    }
  },

  watch: {
    'locationData.locations'(data){
        const myMarkerIconPin = icon({
          iconUrl: require('../../assets/svg/pin.png'),
          iconSize: [42 ,42],
        });

        let createNewMarker = [];

        data.map((t)=>{
            const newMarker             =  {
              id: t.id,
              position: latLng(t.lat,t.lng),
              visible: true,
              icon: myMarkerIconPin,
              title : t.title,
            }

            createNewMarker = [...createNewMarker,newMarker]
        })

        this.markers = createNewMarker;
    }

  },

  created() {


  },

  mounted() {
    this.setIconMarkers();
  },

  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },

    centerUpdate(center) {
      this.currentCenter = center;
    },

    addMarker(data) {
      const currentPlaceLatlng    = data.latlng;
      const findCurrentParent     = data.originalEvent.target.parentNode.className;
      const lat                   = currentPlaceLatlng.lat;
      const lng                   = currentPlaceLatlng.lng;
      // this.markers[0].position    =  latLng(lat,lng );

      const NewlatLng = {
        lat : lat,
        lng : lng,
      }

      this.$emit('latLngCallBack',NewlatLng)
    },

    setIconMarkers(){
      const myMarkerIconPin = icon({
        iconUrl: require('../../assets/svg/pin.png'),
        iconSize: [42 ,42],
      });
      let newMarker = {};

      this.locationData.locations.map((t,i)=>{

        if (typeof(t.position) != 'undefined') {
            t.lat = t.position.coordinates[1];
            t.lng = t.position.coordinates[0];

           newMarker =  {
            id: t.id,
            position: latLng(t.position.coordinates[1],t.position.coordinates[0]),
            visible: true,
            icon: myMarkerIconPin,
            title : t.title,
          }
        }
        else {
            newMarker =  {
             id: t.id,
             position: latLng(t.lat,t.lng),
             visible: true,
             icon: myMarkerIconPin,
             title : t.title,
           }
        }

          this.markers = [...this.markers,newMarker]
      })

    }


  }


}
</script>
